module.exports = __webpack_public_path__ + "static/media/Hawaii-map-cutout-VP.cc22865b.png";